/**
 * Activity log state – My Activity / Team Activity.
 * Placeholder until API is connected.
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ActivityLogEntry {
  id: string | number;
  action: string;
  module: string;
  description: string;
  user: {
    id?: string | number;
    email: string;
    name?: string;
    initials?: string;
    role?: string;
  };
  created_at: string;
  date?: string;
  time?: string;
  details?: string;
  [key: string]: unknown;
}

export interface ActivityLogState {
  entries: ActivityLogEntry[];
  scope: "personal" | "team";
  loading: boolean;
  error: string | null;
  totalCount: number;
  filteredCount: number;
}

const initialState: ActivityLogState = {
  entries: [],
  scope: "team",
  loading: false,
  error: null,
  totalCount: 0,
  filteredCount: 0,
};

const activityLogSlice = createSlice({
  name: "activityLog",
  initialState,
  reducers: {
    setActivityLogEntries: (state, action: PayloadAction<ActivityLogEntry[]>) => {
      state.entries = action.payload;
    },
    setActivityLogScope: (state, action: PayloadAction<"personal" | "team">) => {
      state.scope = action.payload;
    },
    setActivityLogLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setActivityLogError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setActivityLogCounts: (
      state,
      action: PayloadAction<{ totalCount: number; filteredCount: number }>
    ) => {
      state.totalCount = action.payload.totalCount;
      state.filteredCount = action.payload.filteredCount;
    },
  },
});

export const {
  setActivityLogEntries,
  setActivityLogScope,
  setActivityLogLoading,
  setActivityLogError,
  setActivityLogCounts,
} = activityLogSlice.actions;
export default activityLogSlice.reducer;
